import React, { useState, useEffect, useRef } from "react";
import { AutoComplete, Button } from "antd";
import { useReactFlow } from "@xyflow/react";
import { buildOptionsData } from "./buildOption";

const Component = (props: any) => {
  const { materials, setMaterials, userInfo, mParams,alldata } = props;
  const [source, setSource] = useState<any>([]);
  const [inputValue, setInputValue] = useState<any>(null);
  const [options, setOptions] = useState<any>([]);
  const [curOption, setCurOption] = useState<any>(null);
  const ref: any = useRef(null);

  useEffect(() => {
    if(alldata){
      const o = buildOptionsData(alldata);
      setSource(o);
    }
  }, [alldata]);

  const {
    addNodes,
    getNodes,
    getEdges,
    fitView,
    deleteElements,
    updateNodeData,
    toObject,
    setViewport,
    updateEdgeData,
  } = useReactFlow();

  useEffect(() => {
    if (materials.length) {
      const result = options.filter((v: any) => {
        return materials.every((n: any) => JSON.stringify(n) !== JSON.stringify(v));
      });
      setOptions(result);
      let es: any = getEdges();
      if (es) {
        es.map((e: any) => {
          let ml: any = {
            label: "各物质摩尔分数",
            field: "z",
            type: "list",
            units: "",
            names: materials.map((m: any) => m.label),
            values: new Array(materials.length).fill(null),
          };
          updateEdgeData(e.id, { materials_list: ml });
          e.data.materials_list = ml;
        });
      }
    }
  }, [materials]);

  useEffect(() => {
    if (curOption) {
      let m: any = [
        ...materials,
        {
          ...curOption,
        },
      ];
      setMaterials(m);
    }
  }, [curOption]);


  //获得焦点动作
  const focusHandle = (e: any) => {
    if (e.target.value) {
      // console.log('e.target.value',e.target.value);
      buildOptions(e.target.value);
    } else {
      const result = source.filter((v: any) => {
        return materials.every((n: any) => JSON.stringify(n) !== JSON.stringify(v));
      });
      setOptions(result);
    }
  };

  //创建options
  const buildOptions = (key: any) => {
    const r: any = [];
    source.map((s: any) => {
      if (s.value.toUpperCase().includes(key.toUpperCase())) {
        r.push(s);
      }
    });

    if (r.length) {
      const result = r.filter((v: any) => {
        return materials.every((n: any) => JSON.stringify(n) !== JSON.stringify(v));
      });

      setOptions(result);
    } else {
      setOptions([{ value: null, label: "无数据" }]);
    }
  };

  //输入查询字符的动作
  const handleSearch = (value: string) => {
    setInputValue(value);
    buildOptions(value);
  };

  //选中动作
  const selectMaterial = (v: any, o: any) => {
    if (v) {
      setCurOption(o);
      setInputValue(null);
    }
  };

  return (
    <tr>
      <td></td>
      <td>
        <AutoComplete
          style={{ width: "100%" }}
          value={inputValue}
          onSearch={handleSearch}
          placeholder={"+ 添加物质"}
          options={options}
          onSelect={selectMaterial}
          onFocus={focusHandle}
          filterOption={(inputValue, option) => {
            return option!.value?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
          }}
        />
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      {/* 修改进料数据源统一注释 */}
      {/* <td></td> */}
    </tr>
  );
};

export default Component;
